
































































































































































































































import {Component} from 'vue-property-decorator';
import Report from '@/pdf/Report';
import Frontpage from '@/pdf/pages/Frontpage.vue';
import ReportBackground from '@/pdf/components/ReportBackground.vue';
import SummaryOverview from '@/pdf/components/SummaryOverview.vue';
import PageFooter from '@/pdf/components/PageFooter.vue';
import SummaryCashflow from '@/pdf/components/SummaryCashflow.vue';
import CompanyCashflow from '@/pdf/pages/CompanyCashflow.vue';
import CompanyCashflowExtended from '@/pdf/pages/CompanyCashflowExtended.vue';
import AppendixCashflow from '@/pdf/pages/AppendixCashflow.vue';
import Liability from '@/pdf/pages/Liability.vue';

@Component({
  components: {
    Frontpage,
    ReportBackground,
    SummaryOverview,
    PageFooter,
    SummaryCashflow,
    CompanyCashflow,
    CompanyCashflowExtended,
    AppendixCashflow,
    Liability,
  },
})
export default class Cashflow extends Report {
  async mounted() {
    await this.loadDocument();
  }
}
